import { PageLayout } from '@/components/layout'
import { Footer } from '@/components/layout/Footer'
import { useSEO } from '@/hooks/useSEO'

export const PrivacyPolicy = () => {
  useSEO({
    title: 'Privacy Policy - Binder Tech Solutions',
    description: 'Privacy Policy for Binder Tech Solutions. Learn how we collect, use, and protect your personal information.',
    keywords: 'privacy policy, data protection, personal information, Binder Tech Solutions',
    url: 'https://bindertech.com/privacy-policy',
    type: 'website',
  })

  return (
    <PageLayout>
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-10 lg:px-20">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-text-main-light dark:text-text-main-dark mb-4">
            Privacy Policy
          </h1>
          <p className="text-text-sub-light dark:text-text-sub-dark">
            Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        <div className="prose prose-lg dark:prose-invert max-w-none">
          <div className="space-y-8 text-text-main-light dark:text-text-main-dark">
            {/* Section 1 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                1. Information Collected
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>Personal information (name, contact details, account data).</li>
                <li>Transaction and service-related information.</li>
                <li>Communications and user-submitted content.</li>
              </ul>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                2. Use of Information
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>To operate, manage, and improve the application.</li>
                <li>To facilitate transactions between users.</li>
                <li>For customer support, security, and compliance purposes.</li>
                <li>For marketing and promotional activities (where permitted).</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                3. Data Sharing
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>User information is shared only as necessary to complete transactions.</li>
                <li>Information may be disclosed to authorities when legally required.</li>
                <li>The platform does not sell personal data to third parties.</li>
              </ul>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                4. Confidentiality & Security
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>Reasonable technical and administrative measures are used to protect data.</li>
                <li>Users are responsible for safeguarding their own login credentials.</li>
                <li>Absolute security cannot be guaranteed.</li>
              </ul>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                5. User Rights & Responsibilities
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>Users must keep their personal information accurate and updated.</li>
                <li>Users must not misuse or disclose other users' personal data.</li>
                <li>Violations of privacy may result in account suspension or legal action.</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                6. Marketing Communications
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>Users may receive promotional messages.</li>
                <li>Users can opt out of marketing communications at any time.</li>
              </ul>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                7. Data Retention
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>Information is retained as long as necessary for operational, legal, or regulatory purposes.</li>
                <li>Inactive or unverified accounts may be deleted.</li>
              </ul>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-text-main-light dark:text-text-main-dark">
                8. Policy Updates
              </h2>
              <ul className="list-disc pl-6 space-y-2 text-text-sub-light dark:text-text-sub-dark">
                <li>The Privacy Policy may be updated periodically.</li>
                <li>Continued use of the application implies acceptance of changes.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </PageLayout>
  )
}

